import { Model } from '../parents/model';

export class ShippingOptionModel extends Model {
  static ATTR_ID = 'id';

  static ATTR_NAME = 'name';

  get name() {
    return this.attributes[ShippingOptionModel.ATTR_NAME];
  }
}
